module.exports = __webpack_public_path__ + "static/media/toasterheart.2fcf9365.svg";